import React, { useState } from 'react';

const Plans = () => {
  const [activeTab, setActiveTab] = useState('home');

  const homePlans = [
    {
      name: 'Basic',
      speed: '2 Mbps',
      price: '*,***',
      period: '/month',
      features: [
        'Unlimited High-Speed Data',
        'Free Standard Installation',
        'Dual-Band WiFi Router',
        '24/7 Customer Support',
        'Up to 5 Devices',
        'Email & Chat Support',
        '99.5% Uptime'
      ],
      featured: false,
      popular: false
    },
    {
      name: 'Plus',
      speed: '6 Mbps',
      price: '*,***',
      period: '/month',
      features: [
        'Unlimited High-Speed Data',
        'Free Premium Installation',
        'Advanced WiFi 6 Router',
        '24/7 Priority Support',
        'Up to 10 Devices',
        'Free IPTV for 1 Month',
        '99.7% Uptime',
        'Parental Controls'
      ],
      featured: true,
      popular: true
    },
    {
      name: 'Premium',
      speed: '20 Mbps',
      price: '*,***',
      period: '/month',
      features: [
        'Unlimited Ultra-Fast Data',
        'Free Premium Installation',
        'Mesh WiFi System',
        '24/7 VIP Support',
        'Unlimited Devices',
        'Free IPTV for 3 Months',
        '99.9% Uptime',
        'Advanced Security Suite',
        'Free Digital Phone Line'
      ],
      featured: false,
      popular: false
    }
  ];

  const businessPlans = [
    {
      name: 'Starter',
      speed: '20 Mbps',
      price: '*,***',
      period: '/month',
      features: [
        'Dedicated Bandwidth',
        'Business-Grade Router',
        '24/7 Priority Support',
        'Static IP Address',
        '99.9% Uptime SLA',
        'Free Installation',
        'Email Hosting (5 Accounts)'
      ],
      featured: false,
      popular: false
    },
    {
      name: 'Professional',
      speed: '50 Mbps',
      price: '**,***',
      period: '/month',
      features: [
        'Dedicated Fiber Connection',
        'Enterprise Router',
        '24/7 Dedicated Support',
        '5 Static IPs',
        '99.95% Uptime SLA',
        'Free Installation & Setup',
        'Email Hosting (25 Accounts)',
        'Advanced Security Suite',
        'Monthly Reports'
      ],
      featured: true,
      popular: true
    },
    {
      name: 'Enterprise',
      speed: '100 Mbps',
      price: 'Contact Us',
      period: '/month',
      features: [
        'Dedicated Fiber Optic',
        'Custom Network Solution',
        '24/7 Dedicated Engineer',
        'Custom Static IPs',
        '99.99% Uptime SLA',
        'Priority Installation',
        'Unlimited Email Hosting',
        'Enterprise Security Suite',
        'Dedicated Account Manager',
        'Custom Service Level Agreement'
      ],
      featured: false,
      popular: false
    }
  ];

  const renderPlanCard = (plan, index) => (
    <div 
      key={index} 
      className={`col-md-6 col-lg-4 ${plan.popular ? 'mt-0 mt-md-4' : 'mt-4'}`}
      data-aos="fade-up"
      data-aos-delay={index * 100}
    >
      <div className={`card h-100 border-0 shadow-sm transition-all ${plan.popular ? 'popular-plan' : 'hover-shadow'}`}>
        {plan.popular && (
          <div className="position-absolute top-0 start-50 translate-middle mt-n3">
            <span className="badge bg-gradient-primary text-white rounded-pill px-4 py-2 border-2 border-white">
              MOST POPULAR
            </span>
          </div>
        )}
        <div className="card-body p-4">
          <h3 className="h4 mb-3 text-center">{plan.name}</h3>
          <div className="speed-display mb-4 text-center">
            <span className="display-4 fw-bold text-primary">{plan.speed}</span>
            <span className="d-block text-muted">Download Speed</span>
          </div>
          <div className="price mb-4 text-center">
            <span className="display-4 fw-bold">
              {plan.price === 'Contact Us' ? 'Contact Us' : `Rs. ${plan.price}`}
            </span>
            {plan.price !== 'Contact Us' && (
              <span className="text-muted">{plan.period}</span>
            )}
          </div>
          <ul className="list-unstyled mb-4">
            {plan.features.map((feature, i) => (
              <li key={i} className="mb-2">
                <i className="fas fa-check-circle text-success me-2"></i>
                {feature}
              </li>
            ))}
          </ul>
          <div className="mt-auto pt-3">
            <button 
              className={`btn btn-lg w-100 ${
                plan.popular 
                  ? 'btn-primary' 
                  : plan.price === 'Contact Us' 
                    ? 'btn-outline-primary' 
                    : 'btn-outline-primary'
              }`}
            >
              {plan.price === 'Contact Us' ? 'Get a Quote' : 'Get Started'}
              <i className="fas fa-arrow-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <section id="packages" className="py-6 py-lg-8 bg-gradient">
      <div className="container">
        <div className="text-center mb-6" data-aos="fade-up">
          <span className="badge bg-soft-primary text-primary rounded-pill px-3 py-2 mb-3">
            <i className="fas fa-tag me-2"></i>Our Plans
          </span>
          <h2 className="display-5 fw-bold mb-3">Internet Packages</h2>
          <p className="lead text-muted mb-5">
            Choose the perfect plan that fits your needs and budget
          </p>
          
          {/* Tabs Navigation */}
          <div className="d-flex justify-content-center mb-5" data-aos="fade-up" data-aos-delay="100">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={`btn btn-lg px-4 py-2 ${
                  activeTab === 'home' ? 'btn-primary' : 'btn-outline-primary'
                }`}
                onClick={() => setActiveTab('home')}
              >
                <i className="fas fa-home me-2"></i> Home Users
              </button>
              <button
                type="button"
                className={`btn btn-lg px-4 py-2 ${
                  activeTab === 'business' ? 'btn-primary' : 'btn-outline-primary'
                }`}
                onClick={() => setActiveTab('business')}
              >
                <i className="fas fa-briefcase me-2"></i> Business
              </button>
            </div>
          </div>
        </div>

        {/* Plans Grid */}
        <div className="row justify-content-center">
          {activeTab === 'home' 
            ? homePlans.map((plan, index) => renderPlanCard(plan, index))
            : businessPlans.map((plan, index) => renderPlanCard(plan, index))
          }
        </div>

        {/* CTA Section */}
        <div className="text-center mt-7" data-aos="fade-up">
          <div className="card border-0 shadow-sm p-4 p-md-5 bg-white rounded-3">
            <div className="row align-items-center">
              <div className="col-lg-8 text-center text-lg-start mb-4 mb-lg-0">
                <h3 className="h4 mb-2">Need a Custom Solution?</h3>
                <p className="text-muted mb-0">
                  Our team will create a personalized internet package tailored to your specific requirements.
                </p>
              </div>
              <div className="col-lg-4 text-center text-lg-end">
                <button className="btn btn-primary btn-lg">
                  Contact Our Sales Team
                  <i className="fas fa-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Plans;
